module.exports = __webpack_public_path__ + "img/logo_vue.82b9c7a5.png";